import { Outlet } from 'react-router-dom';
import AppNavigation from './components/AppNavigation/AppNavigation';
import { AppHeader } from './style/AppHeader';
import { Box } from 'style-utils/components/Box';
import AppLayoutWrapper from './components/AppLayoutWrapper';
import { VivochaSideBanner } from './components/VivochaSideBanner/VivochaSideBanner';
import { OnInputDelay } from 'components/OnInputDelay';

const AppLayout = () => {
  return (
    <AppLayoutWrapper>
      <AppHeader role="heading" aria-level={1}>
        <AppNavigation />
      </AppHeader>
      <Box as="main">
        <VivochaSideBanner />
        <Outlet />
        <OnInputDelay />
      </Box>
    </AppLayoutWrapper>
  );
};
export default AppLayout;
